import { fetchUserId, userCommodity, createAlipayOrder,createWXOrder,focusBaseUrl,appId ,isTest} from '@/api/home'
// import { loadJs } from './loadJs'

import QRCode from "qrcode"

export default {

    data() {
        return {
            options: [
            //     {
            //     value: 'en',
            //     label: 'ENGLISH'
            // },
             {
                value: 'cn',
                label: '中文(简体)'
            }
            // , {
            //     value: 'tw',
            //     label: '中文(繁体)'
            // }
        ],
            languageValue: "cn",

            //用户角色请求信息
            userRequest: {
                userId: '',
                email: ''
            },
            // 区服信息
            cdId: 1,

            // 商品图片列表
            // commodityImgList: [],

            // 商品列表信息
            commodityGroupList: [],

            // 商品信息，用户选择商品
            commodityInfo: {
                price: 0
            },


            /** 获取限量信息 **/
            // 用户购买商品信息
            userCommodityInfo: [],


            /** 商品弹窗控制 **/
            centerDialogVisible: false,
            currentIndex: -1,
            currentInfo: {},


            /** 订单摘要的信息 **/
            userRole: {
                email: ""
            },

            showOrderContent: false,
            showOrderPrice: false,


            /** 数据加载状态 **/
            commodityLoadStatus: false,
            orderLoadStatus: false,
            userLoadStatus: false,

            /** 支付渠道弹窗 **/
            radio: 1,
            payDialogVisible: false,

            //微信二维码
            wxQRCodeVisible:false,
            wxQRCodeURL:"",

        };
    },

    /** 进页面直接调用接口 **/
    mounted() {
        // 获取图片
        // let imgList = [];
        // const files = require.context("@/assets/zh-CN/commodity/", false, /\.*\.jpg|jpeg|png$/).keys();
        // console.log("文件名：" + files);
        // files.forEach((e) => {
        //     imgList.push(require("@/assets/zh-CN/commodity" + e.slice(1)));
        // });
        // console.log(imgList);
        // this.commodityImgList = imgList;

        // 初始化语言
        const lang = this.languageValue;
        this.$i18n.locale = lang;
        this.$store.dispatch('setLanguage', lang);

        // 获取商品列表信息
        this.getCommodityInfos();
        // loadJs('https://mosoga-html.oss-cn-hangzhou.aliyuncs.com/static/greenhat/v2/m/js/footer/footer_en.js')

        // console.log("获取用户ip: ", returnCitySN);
        // const IP = returnCitySN['cip'] // ip
        // const address = returnCitySN["cname"] // 地址
        // console.log("用户ip: ", IP, "; 用户address: ", address);


                            //生成二维码
                            // QRCode.toDataURL("weixin://wxpay/bizpayurl?pr=E9nJtOezz",(err,url)=>{
                            //     if(err){
                            //         console.error("二维码生成失败",err);
                            //         this.$message({
                            //             message: "二维码生成失败",
                            //             center: true,
                            //             type: 'error',
                            //             showClose: true,
                            //         });
                            //     }
                            //     this.wxQRCodeVisible=true;
                            //     this.wxQRCodeURL=url;
            
                            //     this.orderLoadStatus = false;
                            //     this.payDialogVisible = false;    
                            //   })
        
        
    },
    computed: {
        language() {
            // console.log("this.$store.getters.language", this.$store.getters.language)
            return this.$store.getters.language
        },
    },

    methods: {
        /** 判断是否是手机 **/
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },

        /** 多语言 **/
        handleSetLanguage() {
            const lang = this.languageValue;
            this.$i18n.locale = lang;
            this.$store.dispatch('setLanguage', lang);
            // alert("多语言: "+ lang);

            // 重新刷新请求
            this.commodityGroupList = [];
            this.getCommodityInfos();
            this.userRole = "";
            this.commodityInfo = { price: 0 };
            this.userRequest = {
                userId: '',
                email: ''
            };
            this.setTitleBg();

        },

        /** 标题背景图 **/
        setTitleBg() {
            const lang = this.languageValue;

            if (this._isMobile()){
                if (lang == 'cn' || lang == 'tw') {
                    return { background: 'url(https://mosoga-html.oss-cn-hangzhou.aliyuncs.com/static/greenhat/v2/img/shop/shop-title-v2.png) no-repeat center ' , width: "601px", height: "80px", "background-size": "45%"}
                } else {
                    return { background: 'url(https://mosoga-html.oss-cn-hangzhou.aliyuncs.com/static/greenhat/v2/img/shop/shop-title-en-v2.png) no-repeat center', width: "601px", height: "80px", "background-size": "88%"  }
                }
            }else {
                if (lang == 'cn' || lang == 'tw') {
                    return { background: 'url(https://mosoga-html.oss-cn-hangzhou.aliyuncs.com/static/greenhat/v2/img/shop/shop-title.png) no-repeat center', width: "775px", height: "115px", top: "13px", "background-size": "76%" }
                } else {
                    return { background: 'url(https://mosoga-html.oss-cn-hangzhou.aliyuncs.com/static/greenhat/v2/img/shop/shop-title-en.png) no-repeat center', width: "775px", height: "115px", "background-size": "100%" }
                }
            }

        },

        /** 角色咨询  所需的接口 **/
        getUserRole() {
            fetchUserId({
                // cdId：0, 则为全部区服。小绿帽目前只有区服1.
                cdId: this.cdId,
                userId: this.userRequest.userId,
            }).then(res => {
                this.userLoadStatus = false;

                if (res == undefined || res.length <= 0) {
                    this.$message({
                        message: this.$t('jsHint.role.notExist'),
                        center: true,
                        type: 'error',
                        showClose: true,
                    });

                    return;
                }
                this.userRole = res[0];
                this.userRole.email = this.userRequest.email;

                // 移动端时，用户咨询点击确认后 弹出 用户信息
                if (this._isMobile()){
                    this.showOrder(true);
                }

                // 获取用户购买商品信息
                this.getUserCommodity();
            })
        },

        /** 用户商品信息 **/
        getUserCommodity() {
            userCommodity({
                cdId: this.cdId,
                userId: this.userRequest.userId,
            }).then(res => {
                this.userCommodityInfo = res;
            })
        },


        /** 商品信息 **/
        getCommodityInfos() {
            this.commodityGroupList = [
                [
                { description: "钻石*180、女神之月*1", name: "月卡", price: "30.00", sku: "11", image_url: "https://mosoga-html.oss-cn-hangzhou.aliyuncs.com/static/greenhat/v2/img/shop/commodity-cn/11.png" },
                { description: "钻石*30", name: "小包钻石", price: "6.00", sku: "101", image_url: "https://mosoga-html.oss-cn-hangzhou.aliyuncs.com/static/greenhat/v2/img/shop/commodity-cn/101.png" },
                { description: "钻石*150", name: "一包钻石", price: "30.00", sku: "102", image_url: "https://mosoga-html.oss-cn-hangzhou.aliyuncs.com/static/greenhat/v2/img/shop/commodity-cn/102.png" },
                { description: "钻石*340", name: "一堆钻石", price: "68.00", sku: "103", image_url: "https://mosoga-html.oss-cn-hangzhou.aliyuncs.com/static/greenhat/v2/img/shop/commodity-cn/103.png" },
                { description: "钻石*640", name: "一大堆钻石", price: "128.00", sku: "104", image_url: "https://mosoga-html.oss-cn-hangzhou.aliyuncs.com/static/greenhat/v2/img/shop/commodity-cn/104.png" },
                { description: "钻石*1640", name: "钻石礼盒", price: "328.00", sku: "105", image_url: "https://mosoga-html.oss-cn-hangzhou.aliyuncs.com/static/greenhat/v2/img/shop/commodity-cn/105.png" },
                { description: "钻石*3240", name: "豪华钻石礼盒", price: "648.00", sku: "106", image_url: "https://mosoga-html.oss-cn-hangzhou.aliyuncs.com/static/greenhat/v2/img/shop/commodity-cn/106.png" },
                ],
                [
                // { description: "面值30元的代金券，可在游戏里购买任意礼包优先消费使用。", name: "30元代金券", price: "30.00", sku: "301", image_url: "https://mosoga-html.oss-cn-hangzhou.aliyuncs.com/static/greenhat/v2/img/shop/commodity-cn/301.png" },
                // { description: "面值60元的代金券，可在游戏里购买任意礼包优先消费使用。", name: "60元代金券", price: "60.00", sku: "302", image_url: "https://mosoga-html.oss-cn-hangzhou.aliyuncs.com/static/greenhat/v2/img/shop/commodity-cn/302.png" },
                // { description: "面值68元的代金券，可在游戏里购买任意礼包优先消费使用。", name: "68元代金券", price: "68.00", sku: "303", image_url: "https://mosoga-html.oss-cn-hangzhou.aliyuncs.com/static/greenhat/v2/img/shop/commodity-cn/303.png" },
                // { description: "面值78元的代金券，可在游戏里购买任意礼包优先消费使用。", name: "78元代金券", price: "78.00", sku: "304", image_url: "https://mosoga-html.oss-cn-hangzhou.aliyuncs.com/static/greenhat/v2/img/shop/commodity-cn/304.png" },
                // { description: "面值128元的代金券，可在游戏里购买任意礼包优先消费使用。", name: "128元代金券", price: "128.00", sku: "305", image_url: "https://mosoga-html.oss-cn-hangzhou.aliyuncs.com/static/greenhat/v2/img/shop/commodity-cn/305.png" },
                // { description: "面值328元的代金券，可在游戏里购买任意礼包优先消费使用。", name: "328元代金券", price: "328.00", sku: "306", image_url: "https://mosoga-html.oss-cn-hangzhou.aliyuncs.com/static/greenhat/v2/img/shop/commodity-cn/306.png" },
                // { description: "面值648元的代金券，可在游戏里购买任意礼包优先消费使用。", name: "648元代金券", price: "648.00", sku: "307", image_url: "https://mosoga-html.oss-cn-hangzhou.aliyuncs.com/static/greenhat/v2/img/shop/commodity-cn/307.png" },
                ]
            ];
        },

        /** 商品详情弹窗 **/
        commodityPop(index, data) {
            this.currentIndex = index;
            this.currentInfo = data;
            this.centerDialogVisible = true;
        },
        // 关闭商品详情弹框
        closeDia() {
            this.centerDialogVisible = false;

        },

        /** 根据当前页面，获取用户对应的地区代码 **/
        getCountry() {
            const language =  this.languageValue;
            let country;
            if (language == "en") {
                country = "US";
            } else if (language == "cn") {
                country = "CN";
            } else if (language == "tw") {
                country = "HK";
            }
            return country;
        },


        /** 点击事件 **/
        // 返回官网
        getOfficialWeb() {
            window.location.href = "http://greenhatcn.mrglee.com/";
        },


        submitUserRoleForm(formName) {
            this.userRole = {};
            this.userLoadStatus = true;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.commodityInfo = { price: 0 }; // 清空所选商品信息
                    for(let fItem of this.commodityGroupList) { //去除商品上的选择标记
                        for (let cItem of fItem){
                            cItem.selectStatus = false;
                        }
                    }

                    // const emailSplit = this.userRequest.email.split("@");
                    // if (emailSplit[0].length <= 4){
                    //     this.$message({
                    //         message: this.$t('userForm.emailErrorRemind'),
                    //         center: true,
                    //         type: 'warning',
                    //         showClose: true,
                    //     });

                    //     this.userLoadStatus = false;
                    //     return false;
                    // }



                    this.getUserRole();

                } else {

                    let errorMsg = this.$t('jsHint.role.infoError');
                    if (this.userRequest.userId.length <= 0){
                        errorMsg = this.$t('userForm.idEmptyRemind');
                    }else if (this.userRequest.email <= 0){
                        errorMsg = this.$t('userForm.emailEmptyRemind');
                    }


                    this.$message({
                        message: errorMsg,
                        center: true,
                        type: 'warning',
                        showClose: true,
                    });
                    this.userLoadStatus = false;
                    return false;
                }
            });
        },
        submitCommodity(param) {
            if (!Object.prototype.hasOwnProperty.call(this.userRole, 'userId') || this.userRole.userId <= 0){
                this.$message({
                    message: this.$t('jsHint.role.input'),
                    center: true,
                    type: 'warning',
                    showClose: true,
                });
                return;
            }

            // 图片带上选择标记
            for(let fItem of this.commodityGroupList) { //item为list中的对象
                for (let cItem of fItem){
                    cItem.selectStatus = false;
                }
            }

            param.selectStatus = !param.selectStatus;
            this.commodityInfo = param;
            this.showOrderContent = true;
        },

        /** 验证订单，并打开支付渠道弹窗 **/
        paymentConfirmation() {
            if (!Object.prototype.hasOwnProperty.call(this.userRole, 'userId') || this.userRole.userId <= 0) {
                this.$message({
                    message: this.$t('jsHint.role.input'),
                    center: true,
                    type: 'warning',
                    showClose: true,
                });
                return;
            }

            const commodityInfo = this.commodityInfo;
            if (!Object.prototype.hasOwnProperty.call(commodityInfo, 'name')) {
                this.$message({
                    message: this.$t('jsHint.shop.choose'),
                    center: true,
                    type: 'warning',
                    showClose: true,
                });
                return;
            }

            // 判定商品时候能够购买
            this.getUserCommodity();

            this.payDialogVisible = true;
        },


        /** 创建订单 **/
        createProductOrder() {
            this.paymentConfirmation();

            // 转换货币 和 国家
            const radio = this.radio;
            if (radio == 1) {
                //微信
                const commodityInfo = this.commodityInfo;
                let goodsId = commodityInfo.sku;

                const userRole = this.userRole;

                this.orderLoadStatus = true;
                createWXOrder({
                    role: userRole.userId,
                    retry: 0,
                    appId: appId,
                    data: {
                        quantity: isTest?0.01: parseFloat(commodityInfo.price),
                        priceCNY:  isTest?0.01:parseFloat( commodityInfo.price),
                        title: commodityInfo.name,
                        goodsId: goodsId,
                        itemId: 0,
                        payWay: "Wechat",
                        others: {
                            returnUrl: "https://cdn.mosoga.net/10204/shop/index.html",//实际上在微信上这个参数会被忽略
                            notifyUrl: focusBaseUrl+"official/notify/"+appId+"/wxpay",
                            productCode:this._isMobile()?"QUICK_WAP_WAY":"FAST_INSTANT_TRADE_PAY",
                            cdId:userRole.cdId,
                            lv:userRole.lv
                        }
                    }
                }).then(res => {
                    if (res == null || res.r == null) {
                        this.$message({
                            message: this.$t('jsHint.order.fail'),
                            center: true,
                            type: 'error',
                            showClose: true,
                        });
                        this.orderLoadStatus = false;
                        this.payDialogVisible = false;
                        return;
                    }

                    let body = res.r
                    console.log(body);

                    //生成二维码
                    QRCode.toDataURL(body,(err,url)=>{
                        if(err){
                            console.error("二维码生成失败",err);
                            this.$message({
                                message: "二维码生成失败",
                                center: true,
                                type: 'error',
                                showClose: true,
                            });
                        }
                        this.wxQRCodeVisible=true;
                        this.wxQRCodeURL=url;
    
                        this.orderLoadStatus = false;
                        this.payDialogVisible = false;    
                      })


                })
            
            } else if (radio == 2) {
                //支付宝
                const commodityInfo = this.commodityInfo;
                let goodsId = commodityInfo.sku;

                const userRole = this.userRole;

                this.orderLoadStatus = true;
                createAlipayOrder({
                    role: userRole.userId,
                    retry: 0,
                    appId: appId,
                    data: {
                        quantity: isTest?0.01: parseFloat(commodityInfo.price),
                        priceCNY:  isTest?0.01:parseFloat( commodityInfo.price),
                        title: commodityInfo.name,
                        goodsId: goodsId,
                        itemId: 0,
                        payWay: "Alipay",
                        others: {
                            returnUrl: "https://cdn.mosoga.net/10204/shop/index.html",
                            notifyUrl: focusBaseUrl+"official/notify/alipay",
                            productCode:this._isMobile()?"QUICK_WAP_WAY":"FAST_INSTANT_TRADE_PAY",
                            cdId:userRole.cdId,
                            lv:userRole.lv
                        }
                    }
                }).then(res => {
                    if (res == null || res.r == null) {
                        this.$message({
                            message: this.$t('jsHint.order.fail'),
                            center: true,
                            type: 'error',
                            showClose: true,
                        });
                        this.orderLoadStatus = false;
                        this.payDialogVisible = false;
                        return;
                    }

                    let body = res.r
                    console.log(body);
                    document.body.innerHTML=body;
                    document.forms[0].submit();

                    // window.location.href = url;
                    // window.open(url);
                    this.orderLoadStatus = false;
                    this.payDialogVisible = false;

                })
            }

        },

        showOrder(showStatue) {
            this.showOrderContent = showStatue;
            if (showStatue) {
                this.$refs.commodityH.style.height = '737px'
            } else {
                this.$refs.commodityH.style.height = '972px'
            }
        }


    }
}